import { Timestamp } from '@firebase/firestore-types';

export namespace Invites {
  export enum IndexField {
    FIRST_NAME = 'firstName',
    GROUPS = 'groups',
  }
}

export class Invite {
  id?: string;
  firstName: string;
  lastName: string;
  email: string;
  groups: string[];
  phoneNumber: string;
  organizationId: string;
  createdAt: Timestamp;
  modifiedAt: Timestamp;
}
